export const moduleNamespace = 'map-components';
